import Vue from 'vue'
import swal from 'sweetalert2'

var notify = {
	success(title = '成功', text = '', next, confirmButtonText = 'OK') {
		swal({
			type: 'success',
			title: title.toString(),
			text: text.toString(),
			confirmButtonText: confirmButtonText
		}).then(() => {
			if (next) {
				next()
			}
		})
	},
	successHtml(title = '成功', htmlText = '', next, confirmButtonText = 'OK') {
		swal({
			type: 'success',
			title: title.toString(),
			html: htmlText.toString(),
			confirmButtonText: confirmButtonText
		}).then(() => {
			if (next) {
				next()
			}
		})
	},
	error(title = 'エラー', text = '', next) {
		swal({
			type: 'error',
			title: title.toString(),
			html: text.toString()
		}).then(() => {
			if (next) {
				next()
			}
		})
	},
	confirm(title = '警告', text, next, confirmButtonText = 'OK', cancelButtonText = 'キャンセル', onCancel = null) {
		swal({
			title: title.toString(),
			html: text.toString(),
			type: 'warning',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: confirmButtonText,
			cancelButtonText: cancelButtonText
		}).then((result) => {
			if (result.value && next) {
				next()
			} else if (result.dismiss === swal.DismissReason.cancel && onCancel) {
				onCancel();
			}
		})
	}
}

Vue.use({
	install(Vue, options) {
		Vue.prototype['$notify'] = notify
	}
})

export default notify


// WEBPACK FOOTER //
// ./src/services/notification.js